"use client";

import type { MouseEvent } from "react";

/**
 * 缩略图上的静音预览：悬停播放，移出就地暂停，再次悬停接着上次的位置放。
 *
 * 挂在**容器**上，不是 video 上 —— 打开详情的点击层是绝对定位盖在视频上的兄弟
 * 节点，挂在视频上的话鼠标停在点击层时根本收不到事件。容器是两者的共同祖先，
 * 所以从容器里 querySelector 拿 video。也因此不需要 ref，能直接用在 .map() 里。
 *
 * 移动端没有 hover，就停在首帧，点进详情看完整播放器。
 */
export const hoverPreviewHandlers = {
	onMouseEnter: (event: MouseEvent<HTMLElement>) => {
		// 快速划过时 pause() 会打断还没 resolve 的 play()，吞掉那个 AbortError
		event.currentTarget
			.querySelector("video")
			?.play()
			.catch(() => {});
	},
	onMouseLeave: (event: MouseEvent<HTMLElement>) => {
		// 不复位 currentTime：停在原地，下次悬停接着放
		event.currentTarget.querySelector("video")?.pause();
	},
};
